export default __webpack_public_path__ + "static/media/elevate-red-poster-1.ee00e234.jpg";